<ng-container *ngIf="!singleSelection">
  <p-multiSelect  #priorityDropdownSelect
                  name="priorityDropdownSelect"
                  class="selected-initiative multi-select"
                  [panelStyleClass]="multiSelectPanelStyleClasses"
                  [options]="availableOptions"
                  [panelStyle]="{'background-color':'#FFF'}"
                  [defaultLabel]="defaultLabel"
                  [filter]="false"
                  [selectedItemsLabel]="selectedItemsLabel"
                  [showHeader]="false"
                  [maxSelectedLabels]="0"
                  [(ngModel)]="selectedOptions"
                  (onChange)="onSelectOption($event)"
                  (onPanelHide)="onPanelHide()"
                  (onPanelShow)="onPanelShow()"
                  [style]="initiativeDropdownInlineStyles"
                  [scrollHeight]="maxHeight"
                  appendTo="body"
                  dropdownIcon="fa fa-fw fa-caret-down"
                  [disabled]="disabled">
    <ng-template let-item let-i="index" pTemplate="item">
      <div class="select-initiative-row-container">
        <div [style.borderLeftColor]="item.value.colorCode" class="select-initiative-content">
          <div class="initiative-date-values" *ngIf="showDates">
            <div class="initiative-date-value" *ngIf="hasDate(item)">{{item.value.startDate}}</div>
            <div class="initiative-date-divider" *ngIf="hasDate(item)"> - </div>
            <div class="initiative-date-value" *ngIf="hasDate(item)">{{item.value.endDate}}</div>
          </div>
          <div class="select-item-template-text hard-break-text" [innerHtml]="item.value.htmlContent"></div>
        </div>
      </div>
    </ng-template>
  </p-multiSelect>
</ng-container>
<ng-container *ngIf="singleSelection">
  <p-dropdown  name="priorityDropdownSelect"
               class="selected-initiative single-select"
               [panelStyleClass]="singleSelectPanelStyleClasses"
               [options]="availableOptions"
               [panelStyle]="{'background-color':'#FFF'}"
               placeholder="Select a Critical Initiative"
               [filter]="false"
               (onChange)="onSelectSingleOption($event)"
               [style]="initiativeDropdownInlineStyles"
               [(ngModel)]="selectedOption"
               [scrollHeight]="maxHeight"
               dropdownIcon="fa fa-fw fa-caret-down"
               [disabled]="disabled">
    <ng-template let-item pTemplate="item">
      <div class="select-initiative-row-container">
        <div [style.borderLeftColor]="item.value.colorCode" class="select-initiative-content">
          <div class="initiative-date-values" *ngIf="showDates">
            <div class="initiative-date-value" *ngIf="hasDate(item)">{{item.value.startDate}}</div>
            <div class="initiative-date-divider" *ngIf="hasDate(item)"> - </div>
            <div class="initiative-date-value" *ngIf="hasDate(item)">{{item.value.endDate}}</div>
          </div>
          <div class="select-item-template-text hard-break-text" [innerHtml]="item.value.htmlContent"></div>
        </div>
      </div>
    </ng-template>
    <ng-template let-item pTemplate="selectedItem">
      <div class="select-initiative-row-container" [style.borderLeftColor]="item.value.colorCode">
        <div class="select-initiative-content">
          <div class="initiative-date-values" *ngIf="showDates">
            <div class="initiative-date-value" *ngIf="hasDate(item)">{{item.value.startDate}}</div>
            <div class="initiative-date-divider" *ngIf="hasDate(item)"> - </div>
            <div class="initiative-date-value" *ngIf="hasDate(item)">{{item.value.endDate}}</div>
          </div>
          <div class="select-item-template-text hard-break-text" [innerHtml]="item.value.htmlContent"></div>
        </div>
      </div>
    </ng-template>
  </p-dropdown>
</ng-container>
